import { Route, Routes } from "react-router";

import { ClientContent } from "../Customers/ClientContent";

import { ChargingContent } from "../Charging/ChargingContent";
import { ContactContainer } from "../Contact/ContactContainer";
import { ListDoors } from "../Doors/ListDoors";
import { CalendarContent } from "../KeyManagement/CalendarContent";
import { LaunchInit } from "../LaunchInit";
import { LocationDetails } from "../Location/LocationDetails";
import { ListLocations } from "../Locations/ListLocations";
import { AdminLogin } from "../Login/AdminLogin";
import { UserDetails } from "../Login/UserDetails";
import { UserManualContent } from "../Support/UserManuals";

export const Router = () => (
	<Routes>
		<Route path="/locations/:id" element={<LocationDetails />} />
		<Route path="/locations" element={<ListLocations />} />
		<Route path="/doors" element={<ListDoors />} />
		<Route path="/customers" element={<ClientContent />} />

		<Route path="/login" element={<AdminLogin />} />

		<Route path="/details" element={<UserDetails />} />

		<Route path="/contact" element={<ContactContainer />} />

		<Route path="/charging" element={<ChargingContent />} />

		<Route path="/residents" element={<CalendarContent />} />
		<Route path="/support" element={<UserManualContent />} />

		<Route path="/" element={<LaunchInit />} />
	</Routes>
);
